import { render, staticRenderFns } from "./SamplesList.vue?vue&type=template&id=4d3ab3ee&scoped=true"
import script from "./SamplesList.vue?vue&type=script&lang=js"
export * from "./SamplesList.vue?vue&type=script&lang=js"
import style0 from "./SamplesList.vue?vue&type=style&index=0&id=4d3ab3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ab3ee",
  null
  
)

export default component.exports